import { Add as AddIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { Grid, IconButton } from "@mui/material";
import type { FC } from "react";
import DateRangePicker from "../../../../components/dateRangePicker/DateRangePicker";
import DaysOfWeek, { daysOfWeek } from "./DaysOfWeek";

interface Range {
  start: string;
  end: string;
}

interface Props {
  ranges: { dates: Range; daysOfWeek: boolean[] }[];
  disabled?: boolean;
  withDaysOfWeek: boolean;
  onChange: (ranges: { dates: Range; daysOfWeek: boolean[] }[]) => void;
}

const DateRangeGroup: FC<Props> = ({ ranges, withDaysOfWeek, disabled, onChange }) => {
  const handleDatesChange = (changeIdx: number, dates: Range) => {
    onChange(ranges.map((r, idx) => (idx === changeIdx ? { ...r, dates } : r)));
  };

  const handleDaysOfWeekChange = (changeIdx: number, daysOfWeek: boolean[]) => {
    onChange(ranges.map((r, idx) => (idx === changeIdx ? { ...r, daysOfWeek } : r)));
  };

  const handleDeleteRange = (idxToDelete: number) => {
    onChange(ranges.filter((_, idx) => idx !== idxToDelete));
  };

  const handleAddRange = () => {
    onChange([...ranges, { dates: { start: "", end: "" }, daysOfWeek: daysOfWeek.map(() => true) }]);
  };

  return (
    <Grid container spacing={2}>
      {ranges.map(({ dates, daysOfWeek }, idx) => (
        <Grid key={idx} container size={12} spacing={1}>
          <Grid size={12}>
            <DaysOfWeek
              selectedDays={daysOfWeek}
              disabled={!withDaysOfWeek}
              onSelectionChange={(v) => handleDaysOfWeekChange(idx, v)}
            />
          </Grid>
          <Grid size={10}>
            <DateRangePicker
              disabled={disabled}
              startDate={dates.start}
              endDate={dates.end}
              onStartDateChange={(v) => handleDatesChange(idx, { start: v, end: dates.end })}
              onEndDateChange={(v) => handleDatesChange(idx, { start: dates.start, end: v })}
            />
          </Grid>
          <Grid size={1}>
            {idx !== 0 && (
              <IconButton title="Usuń zakres dat" onClick={() => handleDeleteRange(idx)}>
                <DeleteIcon />
              </IconButton>
            )}
          </Grid>
          <Grid size={1}>
            {idx === ranges.length - 1 && (
              <IconButton title="Dodaj zakres dat" onClick={handleAddRange}>
                <AddIcon />
              </IconButton>
            )}
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default DateRangeGroup;
